// extracted by mini-css-extract-plugin
module.exports = {"root":"youtube_root__1iEt6"};